<main class="deletion-page">
  <h1>Delete your ADVIBE account and data</h1>
  <p>Request permanent deletion of your ADVIBE account and the personal data associated with it.
    You can submit a request from this website without installing the app.</p>

  <section aria-labelledby="request-heading" class="request-panel">
    <h2 id="request-heading">How to request deletion</h2>
    <ol>
      <li>Sign in to ADVIBE on the website or in the app.</li>
      <li>Open <strong>Account → Profile → Delete account</strong>.</li>
      <li>Type <strong>DELETE</strong> and select <strong>Request account and data deletion</strong>.</li>
      <li>Check that your profile shows your request as pending. Our team will email you when deletion is complete.</li>
    </ol>
    <a mat-raised-button color="warn" [routerLink]="authService.isAuthenticated() ? '/user/account/profile' : '/auth/login'"
      [queryParams]="authService.isAuthenticated() ? {} : { returnUrl: '/user/account/profile' }">Go to my profile to request deletion</a>
    <h3>Cannot sign in?</h3>
    <p>Email <a href="mailto:info@advibe.co.za?subject=ADVIBE%20account%20and%20data%20deletion%20request">info@advibe.co.za</a>
      with the subject <strong>ADVIBE account and data deletion request</strong>.
      Send the request from your registered email address and state that you want your account and associated personal data deleted.
      If you no longer have access to that email address, tell us so we can help verify account ownership.
      Do not send your password.</p>
  </section>

  <section aria-labelledby="deleted-heading">
    <h2 id="deleted-heading">Data covered by your request</h2>
    <p>Your deletion request covers the following personal data, where it is associated with your account:</p>
    <ul>
      <li>Your login account and profile details, including name, email address, phone number, address, city and identity number.</li>
      <li>Your profile pictures, uploaded documents and other personal files.</li>
      <li>Your messages, enquiries, reviews, favourites, notification history and preferences.</li>
      <li>Personal information associated with your business listings, advertisements, bookings and consent records.</li>
    </ul>
    <p>For shared business records or conversations, we delete your personal information while protecting other users' data.
      Deletion includes associated personal files held by our storage providers.</p>
  </section>

  <section aria-labelledby="retained-heading">
    <h2 id="retained-heading">No data is retained after deletion</h2>
    <p>ADVIBE keeps no account records or associated personal data after deletion is complete.
      This includes billing and transaction records, consent records, deletion audit records and backup copies associated with your account.</p>
    <p>All account data is deleted within <strong>24 hours</strong> of your request.
      There is <strong>no additional retention period</strong>.</p>
  </section>

  <section aria-labelledby="next-heading">
    <h2 id="next-heading">What happens next</h2>
    <p>Submitting a request does not immediately delete your account. Our team verifies ownership and completes deletion within <strong>24 hours</strong> of your request.
      Once completed, account deletion is permanent and cannot be undone.</p>
    <p>Account deletion does not automatically cancel paid subscriptions. Manage subscriptions in your billing settings or with your payment provider.
      You can submit a deletion request while you arrange cancellation.</p>
    <p>For questions about your request, email <a href="mailto:info@advibe.co.za">info@advibe.co.za</a>.
      See our <a routerLink="/privacy-policy">Privacy Policy</a> for more information about personal data.</p>
  </section>
</main>
